__turbopack_context__.v({
  "customInput": "RewriteWithAIPanel-module__eeTLAa__customInput",
  "customRow": "RewriteWithAIPanel-module__eeTLAa__customRow",
  "goButton": "RewriteWithAIPanel-module__eeTLAa__goButton",
  "list": "RewriteWithAIPanel-module__eeTLAa__list",
  "panel": "RewriteWithAIPanel-module__eeTLAa__panel",
  "panelClose": "RewriteWithAIPanel-module__eeTLAa__panelClose",
  "panelHeader": "RewriteWithAIPanel-module__eeTLAa__panelHeader",
  "panelPortaled": "RewriteWithAIPanel-module__eeTLAa__panelPortaled",
  "panelTitle": "RewriteWithAIPanel-module__eeTLAa__panelTitle",
  "promptButton": "RewriteWithAIPanel-module__eeTLAa__promptButton",
});
